import {
  Component,
  NgZone,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Platform } from '@ionic/angular';
import * as $ from 'jquery';
import { ContactPopupService } from './ContactPopup.service';
import { environment } from 'src/environments/environment';
import { NavigationService } from '../../../Shared/Service/Navigation.service';
import { Common } from '../../../Shared/Utility/Common';
import { CommonapiService } from '../../Service/Commonapi.service';
import { SHowCFPPService } from './SHowCFPP.service';

@Component({
  selector: 'app-ContactPopup',
  templateUrl: './ContactPopup.component.html',
})
export class ContactPopupComponent implements OnInit,OnDestroy {
  @Input() customerid: any = '';

  @Input() parentState: any = '';

  @Output() Submit_Event: EventEmitter<any> = new EventEmitter<any>();

  contacts = [];
  contacts1 = [];
  selectedIndex = 0;
  pastedValue = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ContactPcpupServiceapi: ContactPopupService,
    public api: CommonapiService,
    private SHowCFPPService: SHowCFPPService
  ) {}

  state: any = {
    // contactName: { value: "", iserr: false, err_txt: "" },
    // contactTitle: { value: "0", iserr: false, err_txt: "" },
    // contactDesignation: { value: "0", iserr: false, err_txt: "" },
    // contactSpeciality: { value: "0", iserr: false, err_txt: "" },
    // contactMobileNo: { value: "", iserr: false, err_txt: "" },
    // contactEmail: { value: "", iserr: false, err_txt: "" },
    featureSettingsisContactDetail: false,
    contactTitleList: [],
    contactDesignationList: [],
    contactSpecialityList: [],
  };
  showContactPopup: any = '';
  VP_Subscription: Subscription;
  ngOnInit() {
    this.VP_Subscription = this.SHowCFPPService.Receive_info.subscribe(
      (value) => {
        console.log('c value', value);

        if (value) { this.showContactPopup = true;
          this.customerid=value.data.customer_id;
          this.contacts=value.data.contact_list;

          this.contacts1 =Common.JSON_copy( this.init_contac);
          this.GetCustomerDropdownListValues();}
      }
    );

    //alert();
    // $('.AddContactPopup').addClass('pop_active_card');

    //console.log('before', this.parentState.contactDetails.value);
    //this.parentState.contactDetails.value = "2";

  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.VP_Subscription.unsubscribe();
  }
  AddContacts() {
    this.contacts1.push({
      contactName: { value: '', iserr: false, err_txt: '' },
      contactTitle: { value: '0', iserr: false, err_txt: '' },
      contactDesignation: { value: '0', iserr: false, err_txt: '' },
      contactSpeciality: { value: '0', iserr: false, err_txt: '' },
      contactMobileNo: { value: '', iserr: false, err_txt: '' },
      contactEmail: { value: '', iserr: false, err_txt: '' },
    });
  }

  Call_remove_contacts(sel_index: any) {

    let _temp=[];
    this.contacts1.map((x,i)=>{ if(i!=sel_index){ _temp.push(x) } });
    this.contacts1=_temp;
    //this.selectedIndex = 0;
    // $('#confirmdeletecontact').addClass('pop_active_card');
   // this.selectedIndex = sel_index;
  }

  confirmCloseAddContactdelete() {
    this.showContactPopup = false;
    //  $('#confirmdeletecontact').removeClass('pop_active_card');
  }

  confirmdelete_cancel() {
    this.showContactPopup = false;
    // $('#confirmdeletecontact').removeClass('pop_active_card');
  }

  confirmdelete_yes() {
    this.showContactPopup = false;
    // $('#confirmdeletecontact').removeClass('pop_active_card');

    let temp = [];
    this.contacts1.map((x, index) => {
      if (index != this.selectedIndex) {
        temp.push(x);
      }
    });
    this.contacts1 = temp;
  }

  GetCustomerDropdownListValues() {
    this.selectedIndex = 0;
   // this.contacts1 = [];

    // this.state.contactName.value = "";
    // this.state.contactTitle.value= "0";
    // this.state.contactMobileNo.value= "";
    // this.state.contactEmail.value= "";
    // this.state.contactDesignation.value= "0";
    // this.state.contactSpeciality.value= "0";
    var postdata = { CustomerId: ''};
    this.api.loader.startLoading();
    this.ContactPcpupServiceapi.GetCustomerDropdownListValues(postdata,false).then((data) => {
       console.log("GetCustomerDropdownListValues data",data)
      //undefined - bad request
      //[] - no records
      if (data && data != undefined && data != '[]') {
        this.state.contactTitleList = data.contactTitleList;
        this.state.contactDesignationList = data.designationList;
        this.state.contactSpecialityList = data.specialityList;

        let featureSettings = data.featureSettings;

        console.log('featureSettings', featureSettings);
        if (featureSettings != undefined && featureSettings != null) {
          this.state.featureSettingsisContactDetail =
            featureSettings.isContactDetail;
        }
      }

      this.api.loader.stopLoading();
    });

    //default values whenever the popup is opened

  }

  init_contac:any=[ {
    contactName: { value: "", iserr: false, err_txt: "" },
    contactTitle: { value: "0", iserr: false, err_txt: "" },
    contactDesignation: { value: "0", iserr: false, err_txt: "" },
    contactSpeciality: { value: "0", iserr: false, err_txt: "" },
    contactMobileNo: { value: "", iserr: false, err_txt: "" },
    contactEmail: { value: "", iserr: false, err_txt: "" }
  }]

  CloseAddContact() {
    this.showContactPopup = false;
    //$('.AddContactPopup').removeClass('pop_active_card');
  }

  Submit_AddContact() {
    this.contacts = [];
    let isvalid = true;

    if (this.contacts1.length < 1) {
      isvalid = false;
      return false;
    }

    this.contacts1.map((x, index) => {
      // if ((x.contactName.value) == "") {
      //   x.contactName.iserr = true; x.contactName.err_txt = "Enter contact name";

      // }

      if (x.contactName.value == '') {
        x.contactName.iserr = true;
        x.contactName.err_txt = 'Enter contact name';
        if(isvalid)
        Common.scrollToTop('txtaddcontact' + index + 'Name');
        isvalid = false;

      } else if (x.contactName.value == '') {
        x.contactName.iserr = false;
        x.contactName.err_txt = '';
      }

      if (x.contactDesignation.value == '0') {
        x.contactDesignation.iserr = true;
        x.contactDesignation.err_txt = 'Select Profession';

        if(isvalid)
        Common.scrollToTop('drpcontact' + index + 'Designation');
        isvalid = false;
      } else if (x.contactDesignation.value != '') {
        x.contactDesignation.iserr = false;
        x.contactDesignation.err_txt = '';
      }
      if (this.state.featureSettingsisContactDetail) {
        if (x.contactSpeciality.value == '0') {
          x.contactSpeciality.iserr = true;
          x.contactSpeciality.err_txt = 'Select Detail';

          if(isvalid)
          Common.scrollToTop('drpcontact' + index + 'Speciality');
          isvalid = false;
        } else if (x.contactSpeciality.value != '') {
          x.contactSpeciality.iserr = false;
          x.contactSpeciality.err_txt = '';
        }
      }

      if (x.contactMobileNo.value == '') {
        x.contactMobileNo.iserr = false;
        x.contactMobileNo.err_txt = '';
      } else {
        if (x.contactMobileNo.value.length != 10) {
          x.contactMobileNo.iserr = true;
          x.contactMobileNo.err_txt = 'Enter valid mobile number';

          if(isvalid)
          Common.scrollToTop('txtaddcontact' + index + 'Mobile');
          isvalid = false;
        } else {
          x.contactMobileNo.iserr = false;
          x.contactMobileNo.err_txt = '';
        }

        // if (x.contactMobileNo.value.length == 10) {
        //   let mobileno = new RegExp(/^[6789]\d{9}$/);
        //   if (mobileno.test(x.contactMobileNo.value) == false) {
        //     x.contactMobileNo.iserr = true;
        //     x.contactMobileNo.err_txt = 'Enter valid mobile number';

        //     if(isvalid)
        //     Common.scrollToTop('txtaddcontact' + index + 'Mobile');
        //     isvalid = false;
        //   } else {
        //     x.contactMobileNo.iserr = false;
        //     x.contactMobileNo.err_txt = '';
        //   }
        // }
      }

      if (x.contactEmail.value != '') {
        if (Common.validateEmail(x.contactEmail.value) == false) {

          x.contactEmail.iserr = true;
          x.contactEmail.err_txt = 'Enter valid contact email ID';
          if(isvalid)
          Common.scrollToTop('txtaddcontact' + index + 'Email');
          isvalid = false;
        } else {
          x.contactEmail.iserr = false;
          x.contactEmail.err_txt = '';
        }
      }
    });

    if (isvalid) {
      this.contacts1.map((y, index) => {
        var contactElements = {};
        contactElements['Name'] = y.contactName.value;
        contactElements['Title'] = y.contactTitle.value;
        contactElements['Mobile'] = y.contactMobileNo.value;
        contactElements['Email'] = y.contactEmail.value;
        contactElements['Designation'] = y.contactDesignation.value;
        if (this.state.featureSettingsisContactDetail) {
          contactElements['Speciality'] = y.contactSpeciality.value;
        } else {
          contactElements['Speciality'] = '0';
        }

        this.contacts.push(contactElements);
      });

      console.log('final list', this.contacts);

    //  this.parentState.contactFinalList = this.contacts;
      //console.log('submit', this.parentState.contactDetails.value);
    // console.log('submit', this.parentState.contactFinalList);
      // this.Submit_Event.emit(this.parentState);
      var postdata = {
        CustomerCode: this.customerid,
        contacts:  this.contacts,
      };

      console.log('postdata', postdata);
      this.api.loader.startLoading();
      this.ContactPcpupServiceapi.saveContactPopup(postdata, false).then(
        (data) => {
          console.log('contact data', data);
          let dropdownList: any = [];
          data.addContactNames.map((y, index) => {
            // if(y.id!=-99)
            dropdownList.push({
              id: y.id,
              name: y.name,
              code: y.code,
              designation: y.designation,
            });
          });
          let _ret: any = {
            contactsList: data.addContactNames,
            dropdownList: dropdownList,
          };
          this.api.loader.stopLoading();
        //  this.Submit_Event.emit(_ret);
          this.SHowCFPPService.save_info.next({customr_id:this.customerid,ret:_ret})
          this.showContactPopup = false;
        }
      );
    }
  }

  // Submit_AddContactold() {
  //   this.contacts = [];
  //   let isvalid = true;

  //   if (this.state.contactName.value == '') {
  //     this.state.contactName.iserr = true;
  //     this.state.contactName.err_txt = 'Enter contact name';
  //     isvalid = false;
  //   } else if (this.state.contactName.value == '') {
  //     this.state.contactName.iserr = false;
  //     this.state.contactName.err_txt = '';
  //   }

  //   if (this.state.contactDesignation.value == '0') {
  //     this.state.contactDesignation.iserr = true;
  //     this.state.contactDesignation.err_txt = 'Select job title';
  //     isvalid = false;
  //   } else if (this.state.contactDesignation.value != '') {
  //     this.state.contactDesignation.iserr = false;
  //     this.state.contactDesignation.err_txt = '';
  //   }

  //   if (this.state.contactMobileNo.value == '') {
  //     this.state.contactMobileNo.iserr = false;
  //     this.state.contactMobileNo.err_txt = '';
  //   } else {
  //     let mobileno = new RegExp(/^[789]\d{9}$/);
  //     if (mobileno.test(this.state.contactMobileNo.value) == false) {
  //       this.state.contactMobileNo.iserr = true;
  //       this.state.contactMobileNo.err_txt = 'Enter valid mobile number';
  //       isvalid = false;
  //     } else {
  //       this.state.contactMobileNo.iserr = false;
  //       this.state.contactMobileNo.err_txt = '';
  //     }
  //   }

  //   if (this.state.contactEmail.value != '') {
  //     if (Common.validateEmail(this.state.contactEmail.value) == false) {
  //       isvalid = false;
  //       this.state.contactEmail.iserr = true;
  //       this.state.contactEmail.err_txt = 'Enter valid contact email ID';
  //     } else {
  //       this.state.contactEmail.iserr = false;
  //       this.state.contactEmail.err_txt = '';
  //     }
  //   }

  //   if (isvalid) {
  //     var contactElements = {};
  //     contactElements['Name'] = this.state.contactName.value;
  //     contactElements['Title'] = this.state.contactTitle.value;
  //     contactElements['Mobile'] = this.state.contactMobileNo.value;
  //     contactElements['Email'] = this.state.contactEmail.value;
  //     contactElements['Designation'] = this.state.contactDesignation.value;
  //     contactElements['Speciality'] = this.state.contactSpeciality.value;
  //     this.contacts.push(contactElements);

  //     // contact1Elements["Name"] = "this.state.cust_det.contact1Name.value";
  //     // contact1Elements["Title"] = "this.state.cust_det.contact1Title.value";
  //     // contact1Elements["Mobile"] = "this.state.cust_det.contact1MobileNo.value";
  //     // contact1Elements["Email"] = "this.state.cust_det.contact1Email.value";
  //     // contact1Elements["Designation"] = "this.state.cust_det.contact1Designation.value";
  //     // contact1Elements["Speciality"] = "this.state.cust_det.contact1Speciality.value";
  //     // this.contacts.push(contact1Elements);

  //     this.parentState.contactFinalList = this.contacts;
  //     //console.log('submit', this.parentState.contactDetails.value);
  //     console.log('submit', this.parentState.contactFinalList);

  //     var postdata = {
  //       CustomerCode: this.customerid,
  //       contacts: this.parentState.contactFinalList,
  //     };

  //     //console.log("postdata",postdata)
  //     this.api.loader.startLoading();
  //     this.ContactPcpupServiceapi.saveContactPopup(postdata, false).then(
  //       (data) => {
  //         let dropdownList: any = [];

  //         data.addContactNames.map((y, index) => {
  //           console.log('contact', y);
  //           var contactElements = {};
  //           console.log('y', y.id);
  //           contactElements['id'] = y.id;
  //           contactElements['name'] = y.name;
  //           if (y.designation) contactElements['designation'] = y.designation;
  //           else contactElements['designation'] = '';
  //           dropdownList.push(contactElements);
  //         });
  //         let _ret: any = {
  //           contactsList: data.addContactNames,
  //           dropdownList: dropdownList,
  //         };
  //         this.Submit_Event.emit(_ret);
  //       }
  //     );
  //   }
  // }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText: any = clipboardData.getData('text');

    //this.pastedValue1 = pastedText;
    this.pastedValue = pastedText
      .replace('+91', '')
      .replaceAll(' ', '')
      .replaceAll('-', '');

    if (this.pastedValue.length > 10) {
      let firstTwoChars = this.pastedValue.substring(0, 2);
      if (firstTwoChars == '91') {
        this.pastedValue = this.pastedValue.replace('91', '');
      }
    }
  }

  onInput(id1, id2, id3) {
    if (this.pastedValue) {
      $('#' + id1 + id2 + id3).val(this.pastedValue);

      this.contacts1.map((x, index) => {
        if (index == id2) {
          x.contactMobileNo.value = this.pastedValue;
        }
      });

      //this.pastedValue1 = null;
      this.pastedValue = null;
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
